import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { getHasMoreQuestions } from '../../selectors/pagination';
import { MoreReviewsButton } from '../../components/MoreReviewsButton';
import { questionsPaginationRequestAction } from '../../actions/questions';
import { TThunkDispatch } from '../../types/redux';

export function MoreQuestionsButtonContainer() {
  const hasMore = useSelector(getHasMoreQuestions);
  const dispatch = useDispatch<TThunkDispatch>();

  const onClick = React.useCallback(() => {
    dispatch(questionsPaginationRequestAction());
  }, []);

  if (!hasMore) {
    return null;
  }

  return <MoreReviewsButton onClick={onClick} />;
}
